import { render, staticRenderFns } from "./evaluationAdd.vue?vue&type=template&id=bd7b5dd2&scoped=true"
import script from "./evaluationAdd.vue?vue&type=script&lang=js"
export * from "./evaluationAdd.vue?vue&type=script&lang=js"
import style0 from "./evaluationAdd.vue?vue&type=style&index=0&id=bd7b5dd2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7b5dd2",
  null
  
)

export default component.exports